<div class="analysis-chat">
  <!-- Header del chat -->
  <div class="chat-header">
    <div class="chat-header-info">
      <div class="assistant-avatar">
        <i class="pi pi-comments"></i>
      </div>
      <div class="assistant-details">
        <span class="assistant-name">{{ assistantName }}</span>
        <span class="connection-status" [class.connected]="isConnected">
          <span class="status-dot"></span>
          {{ isConnected ? 'Conectado' : 'Conectando...' }}
        </span>
      </div>
    </div>
    <div class="chat-progress" *ngIf="completenessScore > 0">
      <span class="progress-label">Progreso: {{ getProgressPercent() }}%</span>
      <p-progressBar [value]="getProgressPercent()" [showValue]="false" [style]="{'height': '6px'}"></p-progressBar>
    </div>
  </div>

  <!-- Área de mensajes -->
  <div class="chat-messages" #messagesContainer>
    <!-- Loading -->
    <div class="chat-loading" *ngIf="isLoading">
      <div class="loading-dots">
        <span></span><span></span><span></span>
      </div>
      <p>Iniciando análisis de tu caso...</p>
    </div>

    <!-- Error -->
    <div class="chat-error" *ngIf="error && !isLoading">
      <i class="pi pi-exclamation-triangle"></i>
      <p>{{ error }}</p>
      <button pButton label="Reintentar" icon="pi pi-refresh" class="p-button-sm p-button-outlined" (click)="retryConnection()"></button>
    </div>

    <!-- Mensajes -->
    <ng-container *ngIf="!isLoading && !error">
      <div *ngFor="let msg of messages; trackBy: trackByMessageId"
           class="message-wrapper"
           [class.assistant]="isAssistant(msg.sender)"
           [class.client]="isClient(msg.sender)"
           [class.system]="isSystem(msg.sender)">

        <!-- Avatar del asistente -->
        <div class="message-avatar" *ngIf="isAssistant(msg.sender)">
          <i class="pi pi-comments"></i>
        </div>

        <div class="message-bubble">
          <!-- Nombre del remitente -->
          <span class="message-sender" *ngIf="isAssistant(msg.sender)">{{ assistantName }}</span>

          <!-- Contenido del mensaje -->
          <div class="message-content" [innerHTML]="formatMessage(msg.content)"></div>

          <!-- Opciones (para mensajes tipo OPTIONS/QUESTION) -->
          <div class="message-options" *ngIf="msg.options && msg.options.length > 0">
            <button *ngFor="let option of msg.options"
                    class="option-button"
                    (click)="selectOption(option)">
              {{ option }}
            </button>
          </div>

          <!-- Archivo adjunto -->
          <div class="message-file" *ngIf="msg.fileUrl">
            <a [href]="msg.fileUrl" target="_blank" class="file-link">
              <i class="pi pi-file"></i>
              {{ msg.fileName || 'Archivo adjunto' }}
            </a>
          </div>

          <!-- Hora -->
          <span class="message-time">{{ formatTime(msg.fechaCreacion) }}</span>
        </div>
      </div>

      <!-- Indicador de typing -->
      <div class="message-wrapper assistant" *ngIf="isTyping">
        <div class="message-avatar">
          <i class="pi pi-comments"></i>
        </div>
        <div class="message-bubble typing-bubble">
          <div class="typing-indicator">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Input de mensaje -->
  <div class="chat-input" *ngIf="!isLoading && !error">
    <div class="input-wrapper">
      <textarea
        #messageInput
        [(ngModel)]="newMessage"
        (keydown)="onKeyDown($event)"
        placeholder="Escribe tu respuesta..."
        rows="1"
        class="message-textarea"
        [disabled]="isSending">
      </textarea>
      <button
        class="send-button"
        (click)="sendMessage()"
        [disabled]="!newMessage.trim() || isSending">
        <i class="pi pi-send"></i>
      </button>
    </div>
  </div>
</div>
